import styled from "styled-components";
import { Link } from "react-router-dom";

export const InvitationIdCellWrapper = styled(Link)`
	text-decoration: none;
	color: ${({ theme }) => theme.palette.text.primary};
`;
